import * as t from './action_types';
import * as api from '../../api/store/actions';
const INITIAL_STATE = {
    sites: null,
    isLoadingSites: false,
    isLoadingLeagueData: false,
    siteDetails: {},
    selectedSiteNames: [],
    stagedEdits: {},
    validationErrors: null,
    validatedPaths: [],
    templates: {},
    templatesLoading: false,
    detailMode: null,
    // to be keyed by path
    filteDefsSelectedData: {},
    parentSite: null,
    // default based on avail templates if not set
    sport: null,
    // maybe make this more specific?
    leagueData: [],
    tokens: [],
    isLoadingTokens: false,
    isLoadingSite: false,
    siteHistory: [],
    isLoadingSiteHistory: false,
};

const sites = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case t.RESET_SITE_DATA:
            return {
                ...INITIAL_STATE,
            };
        case t.SET_SPORT:
            const { sport } = action.payload;
            return {
                ...state,
                sport,
            };
        case t.UPDATE_SITE_DETAILS: {
            const { data = {} } = action.payload;
            const { sites = [] } = state;
            // make new array, replace in same position
            const updatedSites = sites.map((u) => (u.core.name === data.core.name ? data : u));
            return {
                ...state,
                sites: updatedSites,
            };
        }
        case t.ADD_SITE_DETAILS: {
            const { data = {} } = action.payload;
            const { sites = [] } = state;
            return {
                ...state,
                sites: [data, ...sites],
            };
        }
        case t.SET_STAGED_EDITS: {
            const { data = {} } = action.payload;
            return {
                ...state,
                stagedEdits: { ...data },
            };
        }
        case t.CLEAR_STAGED_EDITS:
            return {
                ...state,
                stagedEdits: {},
            };
        case t.SET_DETAIL_MODE:
            return {
                ...state,
                detailMode: action.payload.mode,
            };
        case t.SET_VALIDATION_ERRORS:
            return {
                ...state,
                validationErrors: action.payload.errors,
            };
        case t.CLEAR_VALIDATION_ERRORS:
            return {
                ...state,
                validationErrors: null,
            };
        case t.SET_VALIDATED_PATHS:
            return {
                ...state,
                validatedPaths: action.payload.validatedPaths,
            };
        case t.SET_SITE_LIST:
            return {
                ...state,
                sites: action.payload.data,
            };
        case t.SET_SITE_CONFIG_TEMPLATES:
            const { templates } = action.payload;
            return {
                ...state,
                templates,
                templatesLoading: false,
            };
        case t.SET_TEMPLATE_LIST_IS_LOADING: {
            const { isLoading } = action.payload;
            return {
                ...state,
                templatesLoading: isLoading,
            };
        }
        case t.SET_SITE_LIST: {
            return {
                ...state,
                sites: action.payload.data,
                isLoadingSites: false,
            };
        }
        case t.SET_LEAGUE_DATA: {
            return {
                ...state,
                leagueData: action.payload.data,
            };
        }
        case api.API_START: {
            if (action.payload.label === t.FETCH_LEAGUE_DATA) {
                return {
                    ...state,
                    isLoadingLeagueData: true,
                };
            }
            if (action.payload.label === t.FETCH_SITE_LIST) {
                return {
                    ...state,
                    isLoadingSites: true,
                };
            }
            if (action.payload.label === t.FETCH_SITE_TOKENS) {
                return {
                    ...state,
                    isLoadingTokens: true,
                };
            }
            if (action.payload.label === t.FETCH_SITE) {
                return {
                    ...state,
                    isLoadingSite: true,
                };
            }
        }
        case api.API_END: {
            if (action.payload.label === t.FETCH_LEAGUE_DATA) {
                return {
                    ...state,
                    isLoadingLeagueData: false,
                };
            }
            if (action.payload.label === t.FETCH_SITE_LIST) {
                return {
                    ...state,
                    isLoadingSites: false,
                };
            }
            if (action.payload.label === t.FETCH_SITE_TOKENS) {
                return {
                    ...state,
                    isLoadingTokens: false,
                };
            }
            if (action.payload.label === t.FETCH_SITE) {
                return {
                    ...state,
                    isLoadingSite: false,
                };
            }
        }
        case t.SET_IS_LOADING: {
            const { isLoading } = action.payload;
            return {
                ...state,
                isLoading,
            };
        }
        case t.SET_IS_SAVING: {
            const { isSaving } = action.payload;
            return {
                ...state,
                isSaving,
            };
        }
        case t.SET_SITE_TOKENS: {
            return {
                ...state,
                tokens: action.payload.tokens || [],
                isLoadingTokens: false,
            };
        }
        case t.CLEAR_SITE_TOKENS:
            return {
                ...state,
                tokens: [],
                isLoadingTokens: false,
            };
        case t.SET_SITE_HISTORY: {
            return {
                ...state,
                siteHistory: action.payload.siteHistory || [],
            };
        }
        case t.CLEAR_SITE_HISTORY:
            return {
                ...state,
                siteHistory: [],
            };
        case t.SET_SITE_HISTORY_IS_LOADING:
            return {
                ...state,
                isLoadingSiteHistory: !!action.payload.isLoading,
            };
        case t.SELECT_SITE: {
            const { name } = action.payload;
            const { selectedSiteNames = [] } = state;
            // shouldn't be necesssary but prevent it from being in the array twice
            const newSelectedSiteNames = selectedSiteNames.filter(
                (existingName) => existingName !== name
            );
            newSelectedSiteNames.push(name);
            return {
                ...state,
                selectedSiteNames: newSelectedSiteNames,
            };
        }
        case t.UNSELECT_SITE: {
            const { name } = action.payload;
            const { selectedSiteNames = [] } = state;
            const newSelectedSiteNames = selectedSiteNames.filter(
                (existingName) => existingName !== name
            );
            return {
                ...state,
                selectedSiteNames: newSelectedSiteNames,
            };
        }
        case t.SELECT_ALL_SITES: {
            const selectedSiteNames = state.sites.map((s) => s.name);
            return {
                ...state,
                selectedSiteNames,
            };
        }
        case t.UNSELECT_ALL_SITES: {
            return {
                ...state,
                selectedSiteNames: [],
            };
        }
        case t.SET_PARENT_SITE: {
            const { parentSite } = action.payload;
            return {
                ...state,
                parentSite,
            };
        }
        case t.UNSET_PARENT_SITE: {
            return {
                ...state,
                parentSite: null,
            };
        }

        default:
            return state;
    }
};

export default sites;
